import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Icon } from '../../primitives';
import { iconsMap } from '../../icons';
export var ResizerHorizontal = function (props) {
    var registerResizeEvents = function () {
        document.addEventListener('mousemove', onResize, false);
        document.addEventListener('mouseup', stopResizing, false);
    };
    var removeResizeEvents = function () {
        document.removeEventListener('mousemove', onResize, false);
        document.removeEventListener('mouseup', stopResizing, false);
    };
    var startResizing = function (e) {
        e.stopPropagation();
        registerResizeEvents();
    };
    var stopResizing = function () {
        removeResizeEvents();
    };
    var resize = function (newWidth) {
        var _a;
        var isValidWidth = newWidth < props.elemMaxWidth && newWidth > props.elemMinWidth;
        if (((_a = props.elemRef) === null || _a === void 0 ? void 0 : _a.current) && isValidWidth) {
            props.elemRef.current.style.width = newWidth + "px";
        }
    };
    var onResize = function (e) {
        e.stopPropagation();
        e.preventDefault();
        e.cancelBubble = true;
        if (props.elemRef.current) {
            if (props.resizeFromLeft) {
                var distanceToRightElemBorder = props.elemRef.current.getBoundingClientRect().right;
                var diffX = e.pageX - distanceToRightElemBorder;
                resize(-diffX);
            }
            else {
                var distanceToLeftElemBorder = props.elemRef.current.getBoundingClientRect().left;
                var diffX = e.pageX - distanceToLeftElemBorder;
                resize(diffX);
            }
        }
    };
    return (React.createElement("div", { className: namespacedClassnames(compKey, { disabled: props.disabled }), onMouseDown: startResizing }, !props.disabled ?
        React.createElement("div", { className: 'resize-placeholder' }, !props.hideDragIcon && React.createElement(Icon, { icon: iconsMap.doubleEdgedArrow }))
        : null));
};
//# sourceMappingURL=index.js.map